<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.service_location_feature.service_location') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.service_location_feature.name_kh') }}
                </label>
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control kh-font"
                    :class="{
                      'is-invalid': errors.has('service_location_name_kh')
                    }"
                    v-model="model.service_location_name_kh"
                    ref="service_location_name_kh"
                    :placeholder="
                      $t(
                        'addministration.service_location_feature.enter_name_kh'
                      )
                    "
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('service_location_name_kh')"
                  >
                    {{ errors.first('service_location_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label required">
                  {{
                    $t('addministration.service_location_feature.name_en')
                  }}</label
                >
                <div class="col-md-7">
                  <input
                    v-model="model.service_location_en"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('service_location_en') }"
                    :placeholder="
                      $t(
                        'addministration.service_location_feature.enter_name_en'
                      )
                    "
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('service_location_en')"
                  >
                    {{ errors.first('service_location_en') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label required">
                  {{
                    $t(
                      'addministration.service_location_feature.contact_person_name'
                    )
                  }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.contact_person"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_person') }"
                    :placeholder="
                      $t(
                        'addministration.service_location_feature.enter_contact_person_name'
                      )
                    "
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_person')"
                  >
                    {{ errors.first('contact_person') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label required">
                  {{
                    $t('addministration.service_location_feature.contact_no_1')
                  }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.contact_number1"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_number1') }"
                    :placeholder="
                      $t(
                        'addministration.service_location_feature.enter_contact_no_1'
                      )
                    "
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_number1')"
                  >
                    {{ errors.first('contact_number1') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{
                    $t('addministration.service_location_feature.contact_no_2')
                  }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.contact_number2"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_number2') }"
                    :placeholder="
                      $t(
                        'addministration.service_location_feature.enter_contact_no_2'
                      )
                    "
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_number2')"
                  >
                    {{ errors.first('contact_number2') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.service_location_feature.address') }}
                </label>
                <div class="col-md-7">
                  <textarea
                    v-model="model.address"
                    class="form-control"
                    :class="{
                      'is-invalid': errors.has('address')
                    }"
                    rows="3"
                    :placeholder="
                      $t(
                        'addministration.service_location_feature.enter_address'
                      )
                    "
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('address')">
                    {{ errors.first('address') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row  text-right">
            <div class="col-lg-12">
              <ts-button
                class="ml-2"
                color="primary"
                :waiting="saving"
                @click="update"
              >
                {{ $t('addministration.service_location_feature.update') }}
              </ts-button>

              <ts-button
                class="ml-2"
                @click="$router.push({ name: 'service-location' })"
              >
                {{ $t('addministration.service_location_feature.cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'service-location-edit',
  props: ['serviceLocation'],
  data() {
    return {
      model: _.cloneDeep(this.serviceLocation),
      saving: false,
      errors: new Errors()
    }
  },
  mounted() {
    this.$refs.service_location_name_kh.focus()
  },
  methods: {
    update() {
      this.saving = true
      this.errors = new Errors()
      this.$store
        .dispatch('serviceLocation/update', Object.assign({}, this.model))
        .then(respons => {
          this.$toasted.success(respons.message)
          this.$router.push({ name: 'service-location' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
